<template>
    <form-container :headerText="title" :width="400" action="editMeisterschaft"
                    :valid-actions="['editMeisterschaft']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-text-field v-model="dataObject.name" :rules="[rules.required]"
                          label="Name (ohne Damen/Herren, z.B. Classic Einzel, Sprint, Tandem, ...)">
            </v-text-field>
            <v-radio-group v-model="dataObject.type" :rules="[rules.required]">
                <v-radio v-for="(type, n) in types"
                        :key="n"
                        :label="type.label"
                        :value="type.value"
                ></v-radio>
            </v-radio-group>
            <div :class="showBewerbsError?'error--text':'grey--text text--darken-1'"
                 style="font-size: 13px">Bewerbtyp:</div>
            <v-radio-group v-model="dataObject.spielTyp" :rules="[rules.required]" class="mt-1" row>
                <v-radio label="Einzel" value="einzel" :disabled="atLeastOneBewerbExisting"/>
                <v-radio label="Tandem" value="doppel" :disabled="atLeastOneBewerbExisting"/>
            </v-radio-group>
            <div :class="showBewerbsError?'error--text':'grey--text text--darken-1'"
                 style="font-size: 13px">Bewerbe für:</div>
            <div class="mb-5">
                <v-checkbox v-for="(bewerb) in meisterschaftBewerbe" :key="bewerb.value"
                            :disabled="currentData?.bewerbeCounter[bewerb.value] > 0"
                            v-model="dataObject.bewerbe" :label="bewerb.label" :value="bewerb.value" hide-details
                            class="d-inline-block mr-6 mt-0"/>
                <div v-if="showBewerbsError" class="error--text" style="font-size: 13px">
                    bitte mindestens eine Option auswählen!
                </div>
            </div>
            <v-text-field v-model="dataObject.sort" :rules="[rules.required]"
                          label="Position für Sortierung in Auswahlliste" type="number">
            </v-text-field>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "@/components/form/formContainer";
    import {FormRules} from "@/services/formRules";
    import ErrorMsg from "@/components/elements/errorMsg";
    import {MEISTERSCHAFT_BEWERBE} from "@/services/data/meisterschaften/bewerb_constants";
    export default {
        components: {ErrorMsg, FormContainer},
        name: "meisterschaft-edit",
        props: ['currentData', 'landesverband'],
        data: () => ({
            rules: null,
            dataObject: {
                id: null,
                name: '',
                nameFull: '',
                isCup: false,
                type: '',
                sort: 10,
                noRanking: true,
                keineDoppelstartKontrolle: true,
                bewerbe: [],
                bewerbeCounter: {f: 0, m: 0, x: 0},
                bewerbeSportJahr: {},
                spielTyp: ''
            },
            error: '',
            showBewerbsError: false,
            meisterschaftBewerbe: MEISTERSCHAFT_BEWERBE
        }),
        computed: {
            types(){ return this.$store.state.local.ligaTypes.filter(type => type.type === 'Meisterschaft') },
            title(){ return this.currentData ? 'Meisterschaft ändern' : 'Meisterschaft anlegen'},
            atLeastOneBewerbExisting(){
                return (this.currentData?.bewerbeCounter?.f??0 +
                      this.currentData?.bewerbeCounter?.m??0 +
                      this.currentData?.bewerbeCounter?.x??0) > 0
            }
        },
        created(){
            this.rules = new FormRules();
        },
        methods: {
            async save(){
                // check if name is unique
                    if ( !this.landesverband.isNotLigaNameDuplicate(this.dataObject) ) {
                        this.error = 'Diese Meisterschaftsbezeichnung ist bereits vergeben, bitte wähle eine andere!';
                        return;
                    }
                // check if bewerbe is set
                    if ( this.dataObject.bewerbe.length === 0 ) {
                        this.showBewerbsError = true;
                        return;
                    }
                // get unique id
                    if ( !this.dataObject.id ) {
                        this.dataObject.id = this.landesverband.getNextId();
                    }
                // save
                    this.landesverband.local.documentUpdates = {
                        ['ligen.' + this.dataObject.id]: {
                            name: this.dataObject.name,
                            nameFull: this.dataObject.nameFull,
                            isCup: this.dataObject.isCup,
                            type: this.dataObject.type,
                            sort: this.dataObject.sort,
                            noRanking: this.dataObject.noRanking,
                            keineDoppelstartKontrolle: this.dataObject.keineDoppelstartKontrolle,
                            bewerbe: this.dataObject.bewerbe,
                            bewerbeCounter: this.dataObject?.bewerbeCounter,
                            bewerbeSportJahr: this.dataObject?.bewerbeSportJahr,
                            spielTyp: this.dataObject.spielTyp
                        },
                    };
                    this.$store.state.local.loader = true;
                    let reply = await this.landesverband.saveEdited();
                    if ( reply.successful ) {
                        if ( this.currentData ) {
                            this.$emit('changeLigaName', this.dataObject);
                        }
                        this.resetDataObject();
                        window.history.back();
                    }
                    this.$store.state.local.loader = false;
            },
            resetDataObject(){
                this.dataObject = {
                    id: null,
                    name: '',
                    nameFull: '',
                    isCup: false,
                    type: '',
                    sort: 10,
                    noRanking: true,
                    keineDoppelstartKontrolle: true,
                    bewerbe: [],
                    bewerbeCounter: {f: 0, m: 0, x: 0},
                    bewerbeSportJahr: {},
                    spielTyp: '',
                };
                this.error = '';
            },
        },
        watch: {
            currentData(){
                if ( this.currentData ) {
                    this.dataObject = JSON.parse(JSON.stringify(this.currentData));
                    if ( this.dataObject.isCup === undefined ) this.dataObject.isCup = false
                    if ( this.dataObject.noRanking === undefined ) this.dataObject.noRanking = true
                    if ( this.dataObject.keineDoppelstartKontrolle === undefined ) this.dataObject.keineDoppelstartKontrolle = true;
                } else {
                    this.resetDataObject();
                }
            },
            'dataObject.bewerbe'(){
                if ( this.dataObject.bewerbe?.length > 0 ) this.showBewerbsError = false
            }
        }

    }
</script>

<style scoped>

</style>